import { useMemo } from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import useBinLevelBinProperties from '~/common/use-bin-level-bin-properties';

export function useLatestBinLevel({ binId }) {
  const { entity: binEntity, loading: binLoading } = useSirenEntity({ href: binId });
  const { entity: levelEntity, loading: levelLoading } = useSirenEntity({
    href: binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bin-level-latest')?.href,
  });

  const response = useBinLevelCommon({ binId, binEntity, levelEntity, loading: levelLoading || binLoading });
  return {
    ...response,
    latestLevel: response?.levelEntity,
  };
}

function useBinLevelCommon({ binId, binEntity, levelEntity, loading }) {
  const {
    binLevelProperties,
    loading: binLevelPropertiesLoading,
  } = useBinLevelBinProperties({ binId });

  const useSmoothedValues = binLevelProperties?.properties.smoothingModel !== 'none';
  const volume = useSmoothedValues
    ? levelEntity?.properties.estimatedVolume ?? levelEntity?.properties.volume
    : levelEntity?.properties.volume;

  const weight = useSmoothedValues
    ? levelEntity?.properties.estimatedWeight ?? levelEntity?.properties.weight
    : levelEntity?.properties.weight;

  const loadingFinal = !binEntity || loading || binLevelPropertiesLoading;

  return useMemo(() => ({
    volume,
    weight,
    publishedAt: levelEntity?.properties.publishedAt,
    loading: loadingFinal,
    levelEntity,
  }), [levelEntity, loadingFinal, volume, weight]);
}
